import { IActionParam, IActionParamForRun } from "@crispico/react-timeline-10000/types/components/ContextMenu/IAction";
import { AbstractAction, AbstractActionLocalState, AbstractActionProps } from "components/ContextMenuRegistry";
import { entityDescriptors } from "@crispico/foundation-react/entity_crud/entityCrudConstants";
import { AppMetaTempGlobals } from "@crispico/foundation-react/AppMetaTempGlobals";
import _ from "lodash";

export class EditAction extends AbstractAction<AbstractActionProps, AbstractActionLocalState> {

    icon = "list alternate outline";
    label = _msg("general.edit");

    isVisible(param: IActionParam) {
        if (param.selection.length !== 1 || typeof param.selection[0] !== "string") {
            return false;
        }
        const entityName = this.getEntityName(param.selection[0]);
        return entityName === "Mission2" || entityName === "Task" || entityName === "MissionEvent2";
    }

    async run(param: IActionParamForRun) {
        const entityName = this.getEntityName(param.selection[0]);
        const entity = this.props.getEntityAt(param.selection[0])!;
        AppMetaTempGlobals.history.push(entityDescriptors[entityName].getEntityEditorUrl(entity.id));
    }
}
